import ObservableObject from './ObservableObject';

export default class Envelope extends ObservableObject {

    left = 0;
    top = 0;
    width = 0;
    height = 0;

    constructor(opts = {}) {
        super();
        this.defineAllProperties();
        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getCenter() {
        return {
            x: (this.left + this.width / 2),
            y: (this.top + this.height / 2)
        }
    }

    bufferByPercent(percent) {

        const dx = this.width * percent;
        const dy = this.height * percent;

        this.left -= dx / 2;
        this.top -= dy / 2;
        this.width += dx;
        this.height += dy;

        return this;
    }

    unionByXY(x, y) {

        let minx = Math.min(this.left, x);
        let miny = Math.min(this.top, y);

        let maxx = Math.max(this.left + this.width, x);
        let maxy = Math.max(this.top + this.height, y);

        this.left = minx;
        this.top = miny;
        this.width = maxx - minx;
        this.height = maxy - miny;

        return this;
    }

    intersectsByXY(x, y, tolerance = 0) {
        return x >= this.left - tolerance &&
            x <= this.left + this.width + tolerance &&
            y >= this.top - tolerance &&
            y <= this.top + this.height + tolerance;
    }

    intersectsByEnvelop(ext, tolerance = 0) {
        return this.intersectsByXY(ext.left, ext.top, tolerance) ||
            this.intersectsByXY(ext.left + ext.width, ext.top + ext.height, tolerance) ||
            this.intersectsByXY(ext.left, ext.top + ext.height, tolerance) ||
            this.intersectsByXY(ext.left + ext.width, ext.top, tolerance) ||
            ext.intersectsByXY(this.left, this.top, tolerance) ||
            ext.intersectsByXY(this.left + this.width, this.top + this.height, tolerance) ||
            ext.intersectsByXY(this.left, this.top + this.height, tolerance) ||
            ext.intersectsByXY(this.left + this.width, this.top, tolerance);
    }

    containsByEnvelop(ext, tolerance = 0) {
        return this.intersectsByXY(ext.left, ext.top, tolerance) &&
            this.intersectsByXY(ext.left + ext.width, ext.top + ext.height, tolerance) &&
            this.intersectsByXY(ext.left, ext.top + ext.height, tolerance) &&
            this.intersectsByXY(ext.left + ext.width, ext.top, tolerance);
    }
}
